'use strict';

const MessageSplitter = require('./lib/message-splitter');
const MessageJoiner = require('./lib/message-joiner');
const NodeRewriter = require('./lib/node-rewriter');
const NodeStreamer = require('./lib/node-streamer');
const Headers = require('./lib/headers');

module.exports = {
    Splitter: MessageSplitter,
    Joiner: MessageJoiner,
    Rewriter: NodeRewriter,
    Streamer: NodeStreamer,
    Headers
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/mailsplit/index.js
// module id = Ag/f
// module chunks = 0